import type { FilterConditionDto } from '../conditions/condition';
import { BdCondition } from '../conditions/condition';

export class BdConjunctionCondition extends BdCondition {
  constructor(
    id: string,
    public conditions: BdCondition[],
  ) {
    super(id);
  }

  toJSON(): FilterConditionDto {
    const conditions: FilterConditionDto[] = [];

    this.conditions.forEach((condition) => {
      conditions.push(condition.toJSON());
    });

    return {
      [this.id]: { conditions },
    };
  }
}
